export const Survey2025JuneEnabled = 'survey_june_2025_cardmembers_enabled'
export const Survey2025JuneFollowUpEnabled = 'survey_june_2025_followup_enabled'
